import { useRef, useEffect, useState } from "react";
import rough from "roughjs/bundled/rough.esm.js";

export default function RoughCircle({
  diameter = 80,
  strokeWidth = 0.9,
  color = "#18181b",
  roughness = 1.1,
  bowing = 1,
  padding = 3,
  className = "",
  style = {},
}) {
  const svgRef = useRef();
  const [size, setSize] = useState(diameter);

  useEffect(() => {
    // Optional: Responsive Größe (z.B. per Prop oder el.parentNode)
    if (!svgRef.current) return;
    svgRef.current.innerHTML = "";
    const rc = rough.svg(svgRef.current);
    const d = size - 2 * padding;
    const node = rc.ellipse(
      size / 2,
      size / 2,
      d,
      d,
      {
        roughness,
        bowing,
        stroke: color,
        strokeWidth,
        fill: "none",
      }
    );
    svgRef.current.appendChild(node);
  }, [size, color, strokeWidth, roughness, bowing, padding]);

  return (
    <svg
      ref={svgRef}
      width={size}
      height={size}
      className={`absolute inset-0 pointer-events-none z-10 ${className}`}
      style={{ ...style }}
    />
  );
}
